@use "variables" as *;

.attributesDialog {
  height: 100% !important;
}
